import { createSelector } from 'reselect';
import { IFormSessionState } from '../reducers/formSessionReducer';
import { RootStore } from '../reducers/index';

const formSessionStateSelector = createSelector(
  (state: RootStore) => state.formSession,
  (formSessionState: IFormSessionState) => formSessionState,
);

export const fieldsSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.fields,
);

export const formDefIdSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.formDefId,
);

export const formSessionLanguageSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.language,
);

export const formTypeSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.formType,
);

export const statusSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.status,
);

export const tokenSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.token,
);

export const tenantIdSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.tenantId,
);

export const accreditationRequestIdSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) =>
    formSessionState.accreditationRequestId,
);

export const credentialProfileIdSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.credentialProfileId,
);

export const eventIdSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.eventId,
);

export const eventsListSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.eventsList,
);

export const formSessionDropdownListSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.dropdownList,
);

export const projectIdSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.projectId,
);

export const continueAsGuestSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.continueAsGuest,
);

export const loginEnabledSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.loginEnabled,
);

export const createAccountEnabledSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) =>
    formSessionState.createAccountEnabled,
);

export const magicFieldsDataSelector = createSelector(
  formSessionStateSelector,
  (formSessionState: IFormSessionState) => formSessionState.magicFieldsData,
);
